<template>
  <span :class="cn(badgeVariants({ variant }), props.class)">
    <slot />
  </span>
</template>

<script setup>
import { cva } from 'class-variance-authority';
import { cn } from '../../utils.js';

const props = defineProps({
  variant: {
    type: String,
    default: 'accent',
  },
  class: {
    type: String,
    default: '',
  },
});

const badgeVariants = cva(
  'inline-flex items-center rounded px-1 py-0.5 text-[11px] font-semibold transition-colors',
  {
    variants: {
      variant: {
        accent: 'bg-accent-400 text-neutral-900',
        secondary: 'bg-secondary-600 text-neutral-50',
        ghost: 'text-neutral-400 border border-neutral-400',
        danger: 'bg-error-400 text-neutral-900',
      },
    },
    defaultVariants: {
      variant: 'accent',
    },
  }
);
</script>
